import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material/Select';
import AdminSearchField from '../../../../components/admin/AdminSearchField';
import { adminCombineSx, adminFormControlSx } from '../../../../styles/adminComponentStyles';
import type { SimpleState } from '../../../../types/locations';
import { formatLabelWithCode } from '../../../../utils/locationFormat';

interface GameReviewFiltersProps {
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  search: string;
  searchPlaceholder: string;
  onStateChange?: (event: SelectChangeEvent<string>) => void;
  selectedState?: string;
  states?: SimpleState[];
  statesLoading?: boolean;
}

const filtersContainerSx = {
  alignItems: { xs: 'stretch', sm: 'center' },
  display: 'flex',
  justifyContent: 'flex-end',
  mb: 1.5,
  width: '100%',
} as const;

const searchFieldSx = {
  maxWidth: { xs: '100%', sm: 360 },
  width: '100%',
} as const;

const stateSelectSx = adminCombineSx(adminFormControlSx, {
  minWidth: { xs: '100%', sm: 220 },
});

const GameReviewFilters: React.FC<GameReviewFiltersProps> = ({
  onSearchChange,
  search,
  searchPlaceholder,
  onStateChange,
  selectedState = '',
  states = [],
  statesLoading = false,
}) => (
  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={filtersContainerSx}>
    {onStateChange && (
      <FormControl size="small" sx={stateSelectSx} disabled={statesLoading}>
        <InputLabel>State</InputLabel>
        <Select value={selectedState} label="State" onChange={onStateChange}>
          <MenuItem value="">All States</MenuItem>
          {states.map((state) => (
            <MenuItem key={`${state.country_code}-${state.state_code}`} value={state.state_code}>
              {formatLabelWithCode(state.state_name, state.state_code)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )}
    <AdminSearchField
      placeholder={searchPlaceholder}
      value={search}
      onChange={onSearchChange}
      sx={searchFieldSx}
    />
  </Stack>
);

export default React.memo(GameReviewFilters);
